
import { ChangeDetectionStrategy, Component, Input, effect, inject, DOCUMENT } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { WhiteLabelFooterCalAuctionsComponent } from './whitelabel/white-label-footer-calauctions.component';
import { WhiteLabelFooterAuctionProsRVAComponent } from './whitelabel/white-label-footer-auctionprosrva.component';
import { WhiteLabelFooterArarityAuctionsComponent } from './whitelabel/white-label-footer-ararity-auctions.component';
import { RASMUS_BRANDING } from './constants/branding';

@Component({
    selector: 'app-footer',
    imports: [RouterModule, ButtonModule, WhiteLabelFooterCalAuctionsComponent, WhiteLabelFooterAuctionProsRVAComponent, WhiteLabelFooterArarityAuctionsComponent],
    template: `
    @if (shouldShowAuctionProsRVAFooter) {
      <white-label-footer-auctionprosrva></white-label-footer-auctionprosrva>
    }
    @if (shouldShowArarityFooter) {
      <white-label-footer-ararity-auctions></white-label-footer-ararity-auctions>
    }
    @if (shouldShowCalAuctionsFooter) {
      <div>
        <white-label-footer-calauctions></white-label-footer-calauctions>
      </div>
    }

    @if (shouldShowRasmusFooter) {
      <footer class="rasmus-footer">
        <div class="auction-section-footer">
          <div class="auction-section-footer__stats">
            <div class="auction-section-footer__stat">
              <span class="auction-section-footer__icon-circle" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.72202 1.97556C5.67043 2.02317 5.65714 2.06884 5.65714 2.1033V9.06593C5.65714 10.8256 6.14268 12.3344 7.01909 13.3854C7.87687 14.4141 9.17454 15.0857 11 15.0857C12.8255 15.0857 14.1231 14.4141 14.9809 13.3854C15.8573 12.3344 16.3429 10.8256 16.3429 9.06593V2.1033C16.3429 2.06884 16.3296 2.02317 16.278 1.97556C16.2251 1.92677 16.1393 1.88571 16.0286 1.88571H5.97143C5.86065 1.88571 5.77487 1.92677 5.72202 1.97556ZM3.77143 2.1033C3.77143 0.872041 4.82888 0 5.97143 0H16.0286C17.1711 0 18.2286 0.872041 18.2286 2.1033V2.51429H19.8C21.015 2.51429 22 3.49926 22 4.71429V7.22857C22 9.62746 20.0807 11.5295 17.8422 11.8836C17.5473 12.8899 17.0801 13.8126 16.4292 14.5931C15.3576 15.8781 13.8395 16.7144 11.9429 16.9212V20.1143H14.7714C15.2922 20.1143 15.7143 20.5364 15.7143 21.0571C15.7143 21.5779 15.2922 22 14.7714 22H7.22857C6.70785 22 6.28571 21.5779 6.28571 21.0571C6.28571 20.5364 6.70785 20.1143 7.22857 20.1143H10.0571V16.9212C8.16049 16.7144 6.64238 15.8781 5.57084 14.5931C4.91995 13.8126 4.45273 12.8899 4.15776 11.8836C1.91927 11.5295 0 9.62746 0 7.22857V4.71429C0 3.49926 0.984974 2.51429 2.2 2.51429H3.77143V2.1033ZM3.77143 4.4H2.2C2.02642 4.4 1.88571 4.54071 1.88571 4.71429V7.22857C1.88571 8.37223 2.69568 9.41372 3.79878 9.84592C3.7805 9.58823 3.77143 9.32798 3.77143 9.06593V4.4ZM18.2012 9.84592C19.3043 9.41372 20.1143 8.37223 20.1143 7.22857V4.71429C20.1143 4.54071 19.9736 4.4 19.8 4.4H18.2286V9.06593C18.2286 9.32798 18.2195 9.58823 18.2012 9.84592Z" fill="#020617"/>
                </svg>
              </span>
              <div class="auction-section-footer__copy">
                <p class="auction-section-footer__title">50+ Years</p>
                <p class="auction-section-footer__subtitle">Auction Leaders</p>
              </div>
            </div>
            <div class="auction-section-footer__stat">
              <span class="auction-section-footer__icon-circle" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                  <path d="M11.8077 0.994354C11.656 0.686868 11.3429 0.492188 11 0.492188C10.6571 0.492188 10.344 0.686868 10.1923 0.994354L7.27975 6.89787L0.771805 7.83878C0.432509 7.88783 0.150484 8.12526 0.0443093 8.45122C-0.0618655 8.77719 0.0262239 9.13517 0.271539 9.37464L4.97688 13.968L3.8677 20.455C3.80996 20.7927 3.94886 21.134 4.22606 21.3354C4.50327 21.5368 4.87075 21.5635 5.17413 21.4042L11 18.3456L16.8259 21.4042C17.1293 21.5635 17.4967 21.5368 17.7739 21.3354C18.0511 21.134 18.19 20.7927 18.1323 20.455L17.0231 13.968L21.7285 9.37464C21.9738 9.13517 22.0619 8.77719 21.9557 8.45122C21.8495 8.12526 21.5675 7.88783 21.2282 7.83878L14.7203 6.89787L11.8077 0.994354Z" fill="#0B008E"/>
                </svg>
              </span>
              <div class="auction-section-footer__copy">
                <p class="auction-section-footer__title">4.4 Stars</p>
                <p class="auction-section-footer__subtitle">Google Reviews</p>
              </div>
            </div>
          </div>
          <div class="auction-section-footer__actions">
            <button
              pButton
              type="button"
              class="auction-section-footer__action-btn"
              [outlined]="true"
              [routerLink]="'/knowledge-base'"
              (click)="handleInternalFooterNavigation()"
            >
              <svg
                class="auction-section-footer__help-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                aria-hidden="true"
              >
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.38453 1.3897C7.56582 1.3897 6.7766 1.5634 6.05873 1.86391C5.34734 2.1617 4.69999 2.60117 4.16013 3.14102C3.62341 3.67775 3.19017 4.32582 2.88034 5.04595C2.5751 5.75543 2.40881 6.54208 2.40881 7.36544C2.40881 8.18415 2.58251 8.97337 2.88302 9.69124C2.94546 9.84041 2.95392 10.0067 2.90693 10.1614L1.73765 14.0123L5.58854 12.8431C5.74553 12.7954 5.91432 12.8048 6.06503 12.8697C6.77451 13.1749 7.56116 13.3412 8.38453 13.3412C9.20324 13.3412 9.99248 13.1675 10.7103 12.867C11.4217 12.5692 12.0691 12.1297 12.6089 11.5898C13.1457 11.0531 13.5789 10.4051 13.8887 9.68494C14.194 8.97546 14.3603 8.18881 14.3603 7.36544C14.3603 6.54674 14.1866 5.75752 13.8861 5.03965C13.5883 4.32825 13.1488 3.68087 12.6089 3.14102C12.0722 2.60429 11.4242 2.17105 10.704 1.86123C9.99457 1.55599 9.20789 1.3897 8.38453 1.3897ZM5.52211 0.581986C6.39777 0.215431 7.36882 0 8.38453 0C9.39557 0 10.3692 0.204314 11.2533 0.584661C12.1267 0.960428 12.9239 1.49068 13.5916 2.15835C14.2562 2.82292 14.7987 3.62091 15.168 4.50303C15.5345 5.37869 15.75 6.34974 15.75 7.36544C15.75 8.37649 15.5457 9.35011 15.1653 10.2342C14.7895 11.1076 14.2593 11.9048 13.5916 12.5725C12.9271 13.237 12.1291 13.7796 11.247 14.1489C10.3713 14.5155 9.40022 14.7309 8.38453 14.7309C7.46434 14.7309 6.57515 14.5616 5.75628 14.2445L0.896719 15.72C0.651326 15.7945 0.384844 15.7278 0.203503 15.5465C0.022163 15.3651 -0.0445493 15.0986 0.0299612 14.8532L1.50643 9.99068C1.19773 9.17816 1.01911 8.29031 1.01911 7.36544C1.01911 6.3544 1.22342 5.38078 1.60377 4.49673C1.97953 3.62333 2.50978 2.82604 3.17746 2.15835C3.84202 1.4938 4.63998 0.951251 5.52211 0.581986Z" fill="#020617"/>
              </svg>
              <span class="p-button-label">Get Help</span>
            </button>
            <button
              pButton
              type="button"
              class="auction-section-footer__action-btn"
              [outlined]="true"
              [routerLink]="'/sellers'"
              (click)="handleInternalFooterNavigation()"
              label="Sell with Rasmus"
            ></button>
          </div>
        </div>
        <button
          pButton
          type="button"
          routerLink="/referrals"
          class="footer-special-offer"
          (click)="handleInternalFooterNavigation()"
        >
          <span class="footer-special-offer__message">We pay up to $10,000 for referrals*</span>
          <span class="footer-special-offer__divider" aria-hidden="true"></span>
          <span class="footer-special-offer__cta">
            <span class="footer-special-offer__cta-text">Refer Now</span>
            <svg class="footer-special-offer__cta-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
              <g clip-path="url(#footerSpecialOfferClip)">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7 1.16667C3.77834 1.16667 1.16667 3.77834 1.16667 7C1.16667 10.2217 3.77834 12.8333 7 12.8333C10.2217 12.8333 12.8333 10.2217 12.8333 7C12.8333 3.77834 10.2217 1.16667 7 1.16667ZM0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7ZM7.41248 3.47641L10.5236 6.58752C10.6375 6.70142 10.6944 6.85071 10.6944 7C10.6944 7.07909 10.6787 7.15451 10.6502 7.22329C10.6217 7.29209 10.5795 7.35655 10.5236 7.41248L7.41248 10.5236C7.18467 10.7514 6.81533 10.7514 6.58752 10.5236C6.35972 10.2958 6.35972 9.92644 6.58752 9.69863L8.70282 7.58333H3.88889C3.56672 7.58333 3.30556 7.32217 3.30556 7C3.30556 6.67783 3.56672 6.41667 3.88889 6.41667H8.70282L6.58752 4.30137C6.35972 4.07356 6.35972 3.70422 6.58752 3.47641C6.81533 3.2486 7.18467 3.2486 7.41248 3.47641Z" fill="white"/>
              </g>
              <defs>
                <clipPath id="footerSpecialOfferClip">
                  <rect width="14" height="14" fill="white"></rect>
                </clipPath>
              </defs>
            </svg>
          </span>
        </button>
        <div class="rasmus-footer__inner">
          <div class="rasmus-footer__top">
            <div class="rasmus-footer__brand">
            <div class="rasmus-footer__logo-group" [attr.aria-label]="logoAriaLabel">
              <img class="rasmus-footer__logo" [src]="logoPrimaryPath" [attr.alt]="logoAriaLabel" width="155" height="19" />
            </div>
              <p class="rasmus-footer__description">{{ brandDescription }}</p>
            </div>
            <div class="rasmus-footer__links">
              @for (section of footerSections; track section.title) {
                <div class="rasmus-footer__column">
                  <p class="rasmus-footer__title">{{ section.title }}</p>
                  @for (link of section.links; track link.label) {
                    @if (link.routerLink) {
                      <a class="rasmus-footer__link" [routerLink]="link.routerLink" (click)="handleInternalFooterNavigation()">{{ link.label }}</a>
                    } @else {
                      <a class="rasmus-footer__link" [href]="link.href">{{ link.label }}</a>
                    }
                  }
                </div>
              }
            </div>
          </div>
        </div>
        <div class="rasmus-footer__bottom">
          <div class="rasmus-footer__bottom-inner">
            <div class="rasmus-footer__social">
              @for (social of socialLinks; track social.label) {
                <a
                  class="rasmus-footer__social-link"
                  [href]="social.href"
                  target="_blank"
                  rel="noreferrer"
                  [attr.aria-label]="social.label"
                  >
                  <img class="rasmus-footer__social-image" [src]="social.icon" [alt]="social.label" width="22" height="22" />
                  <span
                    class="rasmus-footer__social-icon"
                    [class.rasmus-footer__social-icon--facebook]="social.label === 'Facebook'"
                    [class.rasmus-footer__social-icon--instagram]="social.label === 'Instagram'"
                    [class.rasmus-footer__social-icon--youtube]="social.label === 'YouTube'"
                    aria-hidden="true"
                  ></span>
                </a>
              }
            </div>
            <p class="rasmus-footer__copyright">
              © {{ currentYear }} R.L. Rasmus Auctioneers, Inc. All rights reserved
            </p>
          </div>
        </div>
      </footer>
    }
    `,
    styles: [
        `
      .rasmus-footer {
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #ffffff;
        color: var(--surface-500, #64748B);
        font-family: 'Roboto', 'Inter', sans-serif;
      }

      .auction-section-footer {
        display: none;
        width: 100%;
        box-sizing: border-box;
        position: relative;
      }

      .auction-section-footer::before {
        border-top: 1px solid #E4E4E7;
        content: '';
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
      }

      .auction-section-footer__stats {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: center;
        gap: 0;
        padding: 24px 16px;
      }

      .auction-section-footer__stat {
        display: flex;
        align-items: center;
        gap: 8px;
        min-width: 0;
        padding-right: 24px;
      }

      .auction-section-footer__icon-circle {
        display: flex;
        width: 40px;
        height: 40px;
        padding: 10px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-radius: 28px;
        border: 1px solid #F3F2F9;
        background: #F3F2F9;
        box-sizing: border-box;
      }

      .auction-section-footer__copy {
        display: flex;
        flex-direction: column;
        gap: 2px;
        min-width: 0;
      }

      .auction-section-footer__title {
        margin: 0;
        color: #020617;
        font-family: Inter, sans-serif;
        font-size: 16px;
        font-weight: 600;
        line-height: 20px;
      }

      .auction-section-footer__subtitle {
        margin: 0;
        color: #71717A;
        font-family: Inter, sans-serif;
        font-size: 13px;
        font-weight: 400;
        line-height: 19.5px;
      }

      .auction-section-footer__stat + .auction-section-footer__stat {
        border-left: 1px solid #E4E4E7;
        justify-content: flex-start;
        padding-left: 24px;
        padding-right: 0;
      }

      .auction-section-footer__actions {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 8px;
        width: 100%;
        padding: 16px 16px 0;
        position: relative;
        box-sizing: border-box;
      }

      .auction-section-footer__actions::before {
        border-top: 1px solid #E4E4E7;
        content: '';
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
      }

      :host ::ng-deep .auction-section-footer__action-btn.p-button {
        display: flex;
        height: 36px;
        align-items: center;
        justify-content: center;
        gap: 7px;
        border-radius: 6px;
        border: 1px solid #E4E4E7;
        background: #FFFFFF;
        color: #020617;
        font-family: Inter, sans-serif;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        width: 100%;
      }

      :host ::ng-deep .auction-section-footer__action-btn.p-button .p-button-label {
        font-weight: 500;
      }

      .auction-section-footer__help-icon {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
      }

      .footer-special-offer {
        display: none;
        width: 100%;
        margin: 0;
        min-height: 34px;
        height: 34px;
        padding: 0 12px;
        border-radius: 0;
        background: #27272A;
        border: none;
        color: #FFFFFF;
        align-items: center;
        justify-content: space-between;
        gap: 0.5rem;
      }

      :host ::ng-deep .footer-special-offer.p-button:hover,
      :host ::ng-deep .footer-special-offer.p-button:focus,
      :host ::ng-deep .footer-special-offer.p-button:focus-visible,
      :host ::ng-deep .footer-special-offer.p-button:active {
        background: #27272A;
        box-shadow: none;
        filter: none;
        transition: none;
      }

      .footer-special-offer__message {
        color: #FFF;
        font-family: Inter, sans-serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 16px;
        text-align: center;
        flex: 1 1 auto;
      }

      .footer-special-offer__divider {
        width: 1px;
        height: 18px;
        background-color: rgba(255, 255, 255, 0.2);
        flex-shrink: 0;
      }

      .footer-special-offer__cta {
        display: inline-flex;
        align-items: center;
        gap: 0.9rem;
        padding: 0.25rem 0.6rem;
        border-radius: 999px;
        background-color: transparent;
        color: #FFF;
        text-align: center;
        font-family: Inter, sans-serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
        letter-spacing: 0;
        flex-shrink: 0;
      }

      .footer-special-offer__cta-icon {
        width: 14px;
        height: 14px;
        flex-shrink: 0;
      }

      .rasmus-footer__inner {
        width: 100%;
        max-width: 1438px;
        margin: 0 auto;
        padding: 29px 78px 0;
        box-sizing: border-box;
      }

      .rasmus-footer__top {
        display: grid;
        grid-template-columns: minmax(280px, 517px) minmax(280px, 1fr);
        column-gap: 211px;
        row-gap: 24px;
        align-items: start;
      }

      .rasmus-footer__brand {
        display: flex;
        flex-direction: column;
        gap: 12px;
        max-width: 517px;
      }

      .rasmus-footer__logo {
        width: 140px;
        height: auto;
        display: block;
      }

      .rasmus-footer__logo-group {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 140px;
        height: auto;
        gap: 0;
      }

      .rasmus-footer__description {
        margin: 0;
        font-family: var(--Static-Body-Medium-Font, Roboto);
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.25px;
        font-weight: 400;
        color: var(--surface-500, #64748B);
        max-width: 517px;
      }

      .rasmus-footer__links {
        display: flex;
        align-items: flex-start;
        gap: 57px;
        padding-right: 1px;
        min-width: 280px;
        flex-wrap: wrap;
      }

      .rasmus-footer__column {
        display: flex;
        flex-direction: column;
        gap: 18px;
      }

      .rasmus-footer__title {
        margin: 0;
        font-family: Inter, sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: 0;
        color: #0A0A0A;
      }

      .rasmus-footer__link {
        font-family: Inter, sans-serif;
        color: #71717A;
        text-decoration: none;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0;
        font-weight: 500;
      }

      .rasmus-footer__link:hover,
      .rasmus-footer__link:focus {
        color: #0b5ed7;
        text-decoration: underline;
      }

      .rasmus-footer__bottom {
        margin-top: 24px;
        background: #f7f9fc;
        width: 100%;
      }

      .rasmus-footer__bottom-inner {
        width: 100%;
        max-width: 1438px;
        margin: 0 auto;
        padding: 40px 78px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        align-self: stretch;
        box-sizing: border-box;
      }

      .rasmus-footer__social {
        display: flex;
        align-items: center;
        gap: 16px;
      }

      .rasmus-footer__social-link {
        display: inline-flex;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        align-items: center;
        justify-content: center;
      }

      .rasmus-footer__social-image {
        width: 20px;
        height: 20px;
        display: block;
      }

      .rasmus-footer__social-icon {
        width: 20px;
        height: 20px;
        display: none;
        background-color: currentColor;
        mask-repeat: no-repeat;
        mask-position: center;
        mask-size: contain;
        -webkit-mask-repeat: no-repeat;
        -webkit-mask-position: center;
        -webkit-mask-size: contain;
      }

      .rasmus-footer__social-icon--facebook {
        mask-image: url('/assets/img/facebook.svg');
        -webkit-mask-image: url('/assets/img/facebook.svg');
      }

      .rasmus-footer__social-icon--instagram {
        mask-image: url('/assets/img/instagram.svg');
        -webkit-mask-image: url('/assets/img/instagram.svg');
      }

      .rasmus-footer__social-icon--youtube {
        mask-image: url('/assets/img/youtube.svg');
        -webkit-mask-image: url('/assets/img/youtube.svg');
      }

      .rasmus-footer__copyright {
        margin: 0;
        font-family: var(--Static-Body-Medium-Font, Roboto);
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.25px;
        font-weight: 400;
        color: var(--surface-500, #64748B);
      }

      @media (max-width: 1024px) {
        .rasmus-footer__top {
          grid-template-columns: 1fr;
          column-gap: 0;
        }

        .rasmus-footer__links {
          grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
          column-gap: 32px;
        }
      }

      @media (max-width: 768px) {
        .auction-section-footer {
          display: block;
        }

        .footer-special-offer {
          display: inline-flex;
          margin-top: 24px;
        }

        .rasmus-footer__inner {
          padding: 24px 16px 0;
        }

        .rasmus-footer__links {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 40px 32px;
          width: 100%;
          min-width: 0;
        }

        .rasmus-footer__bottom-inner {
          flex-direction: column;
          align-items: flex-start;
          gap: 8px;
          padding: 16px 24px 20px;
        }

        .rasmus-footer__bottom {
          background: #ffffff;
          border-top: 1px solid #E4E4E7;
        }

        .rasmus-footer__social {
          justify-content: flex-start;
        }

        .rasmus-footer__social-link {
          color: #71717A;
        }

        .rasmus-footer__social-image {
          display: none;
        }

        .rasmus-footer__social-icon {
          display: block;
        }

        .rasmus-footer__copyright {
          max-width: 320px;
          text-align: left;
        }
      }
    `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
  @Input() footer?: string;
  @Input() sid = '';
  
  private document = inject(DOCUMENT);
  private router = inject(Router);
  private readonly routerEvent = toSignal(this.router.events, { initialValue: null });
  private pendingScrollReset = false;
  
  public hostname = '';
  public currentYear = new Date().getFullYear();
  /** Shared accessible label for footer brand assets. */
  public readonly logoAriaLabel = RASMUS_BRANDING.logo.ariaLabel;
  /** Primary logo asset path. */
  public readonly logoPrimaryPath = RASMUS_BRANDING.logo.primary;
  /** Short brand description shown in the footer. */
  public readonly brandDescription = 'Rasmus helps people turn assets into opportunity through simple, trusted auctions.';
  /** SIDs that should use the Rasmus-branded footer. */
  private readonly rasmusBrandSids = ['rasmus_auctions_appspot_com', 'superb_ascent_appspot_com'];
  
  public legalLinks: Array<{ label: string; routerLink?: string; href?: string }> = [
    { label: 'Terms', routerLink: '/terms' },
    { label: 'Privacy', routerLink: '/privacy-policy' },
    { label: 'DMCA', routerLink: '/dcma' },
  ];

  public supportLinks: Array<{ label: string; routerLink?: string; href?: string }> = [
    { label: 'Support', routerLink: '/knowledge-base' },
    { label: 'Contact Us', routerLink: '/contact' },
    { label: 'Help', routerLink: '/knowledge-base' },
  ];

  public aboutLinks: Array<{ label: string; routerLink?: string; href?: string }> = [
    { label: 'About Us', routerLink: '/about-us' },
    { label: 'Blog', routerLink: '/blog' },
    { label: 'Rasmus TV', routerLink: '/rasmus-tv' },
  ];

  public sellLinks: Array<{ label: string; routerLink?: string; href?: string }> = [
    { label: 'Sell On Rasmus', routerLink: '/sellers' },
    { label: 'Sell Real Estate', routerLink: '/real-estate' },
  ];

  public buyLinks: Array<{ label: string; routerLink?: string; href?: string }> = [
    { label: 'Buyers', routerLink: '/buyers' },
    { label: 'Get Alerts', routerLink: '/sms-signup' },
  ];

  public footerSections: Array<{ title: string; links: Array<{ label: string; routerLink?: string; href?: string }> }> = [
    { title: 'Support', links: this.supportLinks },
    { title: 'About Us', links: this.aboutLinks },
    { title: 'Legal', links: this.legalLinks },
    { title: 'Sell', links: this.sellLinks },
    { title: 'Buy', links: this.buyLinks },
  ];

  public socialLinks = [
    { label: 'Facebook', href: 'https://www.facebook.com/RasmusAuction', icon: 'assets/img/facebook.svg' },
    { label: 'Instagram', href: 'https://instagram.com/RasmusAuctions', icon: 'assets/img/instagram.svg' },
    { label: 'YouTube', href: 'https://www.youtube.com/@RasmusAuctioneers1', icon: 'assets/img/youtube.svg' },
  ];

  constructor() {
    this.hostname = this.document?.location?.hostname || '';
    effect(() => {
      const event = this.routerEvent();
      if (!(event instanceof NavigationEnd) || !this.pendingScrollReset) {
        return;
      }

      this.pendingScrollReset = false;
      setTimeout(() => this.scrollPageToTop(), 0);
    });
  }

  /**
   * Marks the next internal footer navigation so the destination route starts at the top.
   */
  public handleInternalFooterNavigation(): void {
    this.pendingScrollReset = true;
    this.scrollPageToTop();
  }

  /**
   * Resets the main document scroll position.
   */
  public scrollPageToTop(): void {
    globalThis.window?.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    this.document.querySelector('body')?.scrollTo(0, 0);
    this.document.querySelector('html')?.scrollTo(0, 0);
  }

  get shouldShowAuctionProsRVAFooter(): boolean {
    return this.sid === 'selldudleyresources' && this.hostname !== 'selldudleyresources.com';
  }

  get shouldShowArarityFooter(): boolean {
    return this.sid === 'rasmus_auctions_appspot_com' && this.hostname === 'ararity.auction-engine.com';
  }

  get shouldShowCalAuctionsFooter(): boolean {
    return this.sid === 'cal_auctions_appspot_com';
  }

  get shouldShowRasmusFooter(): boolean {
    const isRasmusBrand = this.isRasmusBrandSid(this.sid);
    const isArarityHost = this.hostname === 'ararity.auction-engine.com';
    if (this.sid === 'rasmus_auctions_appspot_com') {
      return !isArarityHost;
    }
    return isRasmusBrand;
  }

  /**
   * Check if the current SID should use the Rasmus-branded footer.
   */
  private isRasmusBrandSid(currentSid: string): boolean {
    return this.rasmusBrandSids.includes(currentSid);
  }
}
